import { isAnyRealEstateCategory } from '@kijiji/category'

import { CookieRegistry } from '@/constants/cookieRegistry'
import { RemoteParamKeys, useToggle } from '@/lib/firebase/hooks'
import { getCookieByKey } from '@/utils/cookies/getCookieByKey'

export const useMapSRP = (categoryId: number): boolean => {
  const toggle = useToggle(RemoteParamKeys.MAP_SRP)
  const enabled = toggle?.enabled ?? false

  const mapSRPOptInCookie: string =
    typeof document !== 'undefined'
      ? getCookieByKey(document.cookie, CookieRegistry.MAP_SRP_OPT_IN)
      : ''

  const isMapSRPEnabled: boolean =
    enabled && mapSRPOptInCookie === 'enabled' && isAnyRealEstateCategory(categoryId)

  return isMapSRPEnabled
}
